import React from 'react';

const Filtros = props => (
  <div className='pageHead-rowContainer'>
    <div className='pageHead-filters wrapper'>
      <div className='row col-md-10'>
        <div className='col-md-3'>
          <label className='labelInfo' htmlFor='sucursalFilter'>Sucursal</label>
          <div className='select'>
            <select className='form-control' id='sucursalFilter' onChange={props.onChangeAndFilter} name='sucursalFilter' value={props.sucursalFilter}>
              <option value=''>Selecciona una sucursal</option>
              {
                props.sucursales.map(sucursal => (
                  <option
                    key={sucursal.codSucursal}
                    value={sucursal.codSucursal}
                  >
                    {sucursal.nomSucursal}
                  </option>
                ))
              }
            </select>
            <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
          </div>
        </div>
        <div className='col-md-3'>
          <label className='labelInfo' htmlFor='sucursal'>Filial</label>
          <div className='select'>
            <select className='form-control' id='filialFilter' onChange={props.onChangeAndFilter} name='filialFilter' value={props.filialFilter} >
              <option  value=''>Selecciona una filial</option>
              {
                props.filiales.map(filial => (
                  <option
                    key={filial.id}
                    value={filial.id}
                  >
                    {filial.nombre}
                  </option>
                ))
              }
            </select>
            <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
          </div>
        </div>
        

          <div className='row'>
            <div className='col-sm-6'>
            <div class="form-group">
            <label class="labelInfo" for="asesorComercial">Buscar descripción de la ubicación del pedido</label>    
            <div className='select'>
        
            <input 
                    style={{width:'350px'}}
                    class="form-control awesomplete" 
                    placeholder="Buscar certificado"    
                    type='text'
                    name='buscar'
                    id='buscar'
                    value={props.buscar}
                    onChange={ props.onChangetext}
                    onKeyDown={(e) => {
                      if (e.keyCode === 13) {
                        e.preventDefault();
                        props.searchBuscar();
                      }
                    }}
                    />
                <div className='select-control-icon'  style={{backgroundColor:'#f5f5f5',    pointerEvents: 'auto'}}>    
                 <button class="btn btn-blue" onClick={()=>props.searchBuscar()}>Buscar</button>
                </div>
                     </div>

            </div>
            </div>
            </div>

      </div>
      <button className='btn pageHead-tableConf-clean checkDeGrillaCerrar' data-toggle='tooltip' data-placement='top' title='Limpiar filtros' data-original-title='Limpiar filtros' onClick={props.reset}>
        <i className='ion-funnel' />
      </button>
    </div>
  </div>
);

export default Filtros;



// WEBPACK FOOTER //
// ./src/pages/MantUbicacionPedido/Filtros.js